<template>
    
</template>

<script>
    import PreviewElement from "./PreviewElement";
    import ListWrapperElement from "../../components/pagesbuilder/elements/ListWrapperElement";

    export default {
        name: "PreviewListWrapperElement",
        mixins: [
            PreviewElement,
            ListWrapperElement
        ]
    }
</script>

